<a
  class="{{ color() }} {{ font() }}"
  [class.disabled]="disabled()"
  [class.inactive]="inactive()"
  [class.ellipsis]="ellipsis()"
  [tabindex]="disabled() ? -1 : 0"
  [attr.href]="href()"
  [target]="target()"
>
  <ng-content></ng-content>
</a>
